import type { ReactNode } from "react";

// One empty state, everywhere.
//
// An empty region is not a smaller version of a full one: it is the moment a
// person finds out that what they came for is not here, and the screen owes
// them two things — why it is empty, and what to do about it. "No data" is the
// absence of an empty state rather than one.
//
// It lives here because the alternative is what this app had: the same moment
// written as a note in one panel, a bare paragraph in another and a centred
// block with an arrow in a third, so the product looked like three products
// depending on which region happened to be empty.
export function EmptyState({ children, action }: { children: ReactNode; action?: ReactNode }) {
  return (
    <div className="empty-state">
      <p>{children}</p>
      {action ? <div className="empty-state-action">{action}</div> : null}
    </div>
  );
}
